export var setScrollbarWidth = function () {
    var div = document.createElement('div');
    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';
    document.body.append(div);
    document.body.style.setProperty('--dialog-scrollgutter', "".concat(div.offsetWidth - div.clientWidth, "px"));
    div.remove();
};
